import React, { useEffect, useState } from "react";
import starEmpty from "../images/star-empty.svg";
import starFill from "../images/star-fill.svg";
import starHover from "../images/star-fill.svg";
import { useMediaQuery } from "react-responsive";

const StarRating = ({ rating, setRating, setFieldValue, ratingError, setRatingError }) => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [hoveredRating, setHoveredRating] = useState(null);
  const [isHover, setIsHover] = useState(false);

  // Handle star click
  const handleStarClick = (clickedRating) => {
    setRating(clickedRating);
  };

  // Handle star mouse enter
  const handleStarMouseEnter = (hoveredRating) => {
    setHoveredRating(hoveredRating);
    setIsHover(true);
  };

  // Handle star mouse leave
  const handleStarMouseLeave = () => {
    setHoveredRating(null);
    setIsHover(false);
  };

  useEffect(() => {
    setFieldValue("review[rating]", rating);
    setRatingError(false);
  }, [rating]);

  return (
    <div>
      <label style={{
        color: "#2D3948",
        fontSize: 15,
        width: "100%",
        margin: 0
      }}>
        Vertinimas<span style={{
          color: "#EF8B12"
        }}>*</span>
      </label>
      <div style={{
        position: "relative",
        width: "max-content",
        display: "flex",
        gap: isMobileScreen ? 8 : 4,
      }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <img
            key={star}
            src={star <= (hoveredRating || rating) ? (isHover ? starHover : starFill) : starEmpty}
            onMouseEnter={() => handleStarMouseEnter(star)}
            onMouseLeave={handleStarMouseLeave}
            onClick={() => handleStarClick(star)}
            style={{
              width: isMobileScreen ? 40 : 30,
              height: isMobileScreen ? 40 : 30,
              cursor: "pointer",
            }}
          />
        ))}
        <div style={{
          position: "absolute",
          bottom: "-12px",
          left: 0,
          width: "100%",
          color: "#9D9D9D",
          fontSize: 8,
          display: "flex",
          justifyContent: "space-between",
          cursor: "default"
        }}>
          <span>Blogai</span>
          <span>Puikiai</span>
        </div>
      </div>
      {ratingError && (
        <div style={{
          color: "#ff4d4f",
          fontSize: 12,
          marginTop: 12
        }}>
          Privaloma
        </div>
      )}
    </div>
  );
};

export default StarRating;
